import rootReducer from "./reducers/rootReducer";

import { configureStore } from "@reduxjs/toolkit";

const clientStore = configureStore({
  reducer: rootReducer,
});

export default clientStore;
